<app-dialog-default-modal
  confirmText="Save"
  cancelText="Cancel"
  [showCloseIcon]="false"
  (actionClicked)="handleAction($event)"
>
  <ng-container title>
    <h1>Add a custom tag</h1>
  </ng-container>
  <div content class="form-container">
    <form [formGroup]="editTagForm">
      <div *ngIf="formErrors.name != '' || formErrors.category != ''">
        <app-error-display
          *ngIf="formErrors.name != ''"
          [errorMessage]="formErrors.name"
          [size]="'small'"
        ></app-error-display>
        <app-error-display
          *ngIf="formErrors.category != ''"
          [errorMessage]="formErrors.category"
          [size]="'small'"
        ></app-error-display>
      </div>
      <mat-form-field>
        <input
          matInput
          placeholder="Tag name"
          formControlName="name"
          required
        />
      </mat-form-field>

      <div class="d-flex flex-column">
        <label class="form-label small">Tag category *</label>
        <app-categories-and-tags-display
          [tags]="categories"
          [selectedTags]="this.category ? [this.category] : []"
          (tagClicked)="toggleCategorySelection($event)"
          classList="add-custom"
        ></app-categories-and-tags-display>
      </div>
    </form>
  </div>
</app-dialog-default-modal>
